import { resourceOrganizationName } from '../../api/resources';

const state = {
    helpPage: '',
    organizationName: '',
    contactInfo: '',
};

const mutations = {
    SET_HELP(state, val) {
        state.helpPage = val;
    },

    UNSET_HELP(state) {
        state.helpPage = '';
    },

    SET_ORG_NAME(state, name) {
        state.organizationName = name;
    },

    SET_CONTACT_INFO(state, info) {
        state.contactInfo = info;
    },
};

const actions = {
    setHelpPage({ commit }, { help, userType, reportType }) {
        let page = typeof help !== 'function' ? help : help(userType, reportType);
        commit('SET_HELP', page);
    },

    loadOrganizationName({ commit }) {
        return resourceOrganizationName()
            .then(response => {
                commit('SET_ORG_NAME', response.data.name);
                commit('SET_CONTACT_INFO', response.data.description);
            })
            .catch(error => {
                commit('SET_ORG_NAME', '');
                commit('SET_CONTACT_INFO', '');
                return Promise.reject(error);
            });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
